import { useEffect } from "react";
import { useTranslation } from "next-i18next";
import AboutComponent from "@/components/About/AboutComponent";
import useGeneralStore from "@/store/General/useGeneralStore";

const About = () => {
  const { i18n } = useTranslation("common");
  const currentLang = i18n.language || "en";
  const { fetchAboutComponent } = useGeneralStore((state) => ({
    fetchAboutComponent: state.fetchAboutComponent,
  }));

  useEffect(() => {
    fetchAboutComponent(currentLang);
  }, [fetchAboutComponent, currentLang]);

  return <AboutComponent />;
};

export default About;
